module.exports = __webpack_public_path__ + "0b3fe3fc75a18b9e855be4c515c4bf65.svg";